import { all, fork } from 'redux-saga/effects';

import { telemedicineReportSagas } from './telemedicineReport/sagas';

export default function* reportsSagas() {
  yield all([fork(telemedicineReportSagas)]);
}
